export default [
  {
    type: 'index',
    formItems: [
      {
        label: "页面名称",
        name: "title",
        key: "params",
        type: "text",
        stamp: 'input',
        defaultValue: '领取会员卡',
      },
      {
        label: "背景图",
        name: "backgroundImage",
        key: "style",
        stamp: 'singleImage',
        help: "背景比例 750*1334 ,图片大小500kb以内",
        defaultValue: '/web_base_assets/scan/userCardTemplateBase.png',
      },

      {
        label: "背景颜色",
        name: "backgroundColor",
        key: "style",
        type: "color",
        stamp: 'input',
        defaultValue: '#2c2f42',
      }, {
        label: "按钮背景",
        name: "btnBackgroundImage",
        key: "style",
        stamp: 'singleImage',
        help: "背景比例 740*192,文字位置非居中显示,默认背景图底部带边框视觉上制作成居中,位置大概再45%的位置",
        defaultValue: '/web_base_assets/scan/userCardStatusBg.png',
      },
    ]
  },
  {
    type: 'success',
    formItems: [ 
      {
        label: "提示",
        name: "tips",
        key: "params",
        type: "text",
        help:"提示语限16字内",
        stamp: 'input',
        maxLength:16,
        defaultValue: '领取成功',
      },
      {
        label: "背景图",
        name: "icon",
        key: "style",
        stamp: 'singleImage',
        help: "背景比例 750*1334 ,图片大小500kb以内",
        defaultValue: '/web_base_assets/scan/userCardGetSuccess.png',
      },

    ]
  },
  {
    type: 'repeat',
    formItems: [ 
      {
        label: "提示",
        name: "tips",
        key: "params",
        type: "text",
        help:"提示语限16字内",
        stamp: 'input',
        maxLength:16,
        defaultValue: '领取成功',
      },
      {
        label: "背景图",
        name: "icon",
        key: "style",
        stamp: 'singleImage',
        help: "背景比例 750*1334 ,图片大小500kb以内",
        defaultValue: '/web_base_assets/scan/userCardGetSuccess.png',
      },
      {
        label: "文字颜色",
        name: "textColor",
        key: "style",
        type: "color",
        stamp: 'input',
        defaultValue: '#8392BB',
      },
    ]
  },
  {
    type: 'achieve',
    formItems: [
      {
        label: "提示",
        name: "tips",
        key: "params",
        type: "text",
        help:"提示语限16字内",
        stamp: 'input',
        maxLength:16,
        defaultValue: '您已达到该等级',
      },
      {
        label: "背景图",
        name: "icon",
        key: "style",
        stamp: 'singleImage',
        help: "背景比例 750*1334 ,图片大小500kb以内",
        defaultValue: '/web_base_assets/scan/userCardGetSuccess.png',
      },
      {
        label: "文字颜色",
        name: "textColor",
        key: "style",
        type: "color",
        stamp: 'input',
        defaultValue: '#8392BB',
      },

    ]
  },
]